import { mapStateTextDisplay } from 'reg_redesign/redux/connectFunctions';
import { merge } from 'lodash';
import TextDisplay from 'components/component_lib/TextDisplay';

const titleProps = {
  containerStyle: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1.5rem 0',
    flexDirection: 'column'
  },
  textStyle: {
    fontSize: '1.25rem',
    fontWeight: 400,
    lineHeight: '1.5rem',
    textAlign: 'center'
  }
};

const titleConfig = {
  component: TextDisplay,
  name: 'pageTitle',
  stateToPropsOverride: mapStateTextDisplay,
  props: titleProps
};

function configureTitle(textContent, id = null, additionalProps) {
  const props = id ? { id } : {};
  return merge({}, titleConfig, { textContent, props }, additionalProps);
}

export default configureTitle;
